import React, { useState } from 'react'
import { USER_URL } from '../../constant/api'
import { useNavigate } from 'react-router-dom'

function DeleteAccount() {
    const [reason, setReason] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState(null)
    const navigate = useNavigate();

    const handleDelete = async () => {
        setLoading(true)
        if (!reason) {
            setMessage('Please enter a reason for deleting your account.')
            setLoading(false)
            setShowModal(false)
            return
        }
        try {
            const response = await USER_URL.post('/accounts/delete-account/', { reason })
            console.log('Account deleted:', response.data)
            setMessage('Account successfully deleted.')
            navigate('/');
        } catch (error) {
            console.error('Error deleting account:', error)
            setMessage('Failed to delete account. Please try again.')
        }
        setLoading(false)
        setShowModal(false)
    }

    return (
        <div className="min-h-screen flex flex-col items-start p-4">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">Delete My Account</h1>
            <div className="mb-8">
                <p className="text-lg text-black font-semibold mb-2">We are sorry to see you go!</p>
                <p className="mb-4 text-gray-600">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <p className="mb-4 text-gray-600">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <p className="text-gray-600">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
            </div>

            <div className="">
                <p className="text-xl font-semibold mb-2">Account Deletion Request</p>
                <p className="mb-4 text-gray-600">
                    Before you leave, please tell us why you’d like to delete your account. This information will help us improve (optional).
                </p>
                <textarea
                    name="reason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Enter your reason"
                    className="w-full p-3 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    rows="4"
                />
                <button
                    onClick={() => setShowModal(true)}
                    className="w-full border-red-600 border-2 text-red-600 px-4 py-3 rounded hover:text-white hover:bg-red-600 transition"
                >
                    Delete Account
                </button>
                {message && <p className="mt-4 text-center text-green-500">{message}</p>}
            </div>

            {/* Confirmation Modal */}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded shadow-lg p-6 max-w-sm w-full">
                        <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
                        <p className="mb-6 text-gray-700">
                            Are you sure you want to delete your account? This action cannot be undone.
                        </p>
                        <div className="flex justify-end space-x-4">
                            <button
                                onClick={() => setShowModal(false)}
                                className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                                disabled={loading}
                            >
                                {loading ? 'Deleting...' : 'Confirm'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DeleteAccount
